// Customizable Area Start
import React, { CSSProperties, MouseEvent } from "react";
import { Box, Typography, Container } from "@material-ui/core";
import { configJSON } from "./WaitListController.web";
import { Elements } from "@stripe/react-stripe-js";
import WaitListController, { stripePromise } from "./WaitListController.web";
import CustomBackButton from "../../../components/src/CustomBackButton.web";
// Import the exact same StripeForm component used in sign-up
import StripeForm from "../../email-account-registration/src/StripeForm.web";
import { createTheme, ThemeProvider } from "@material-ui/core/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#0000ff",
      contrastText: "#fff",
    },
  },
});

const webStyles: Record<string, CSSProperties> = {
  headingWrapper: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    marginBottom: "66px",
  },
  paymentDetailWrapper: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    height: "100%",
    width: "100%",
  },
  title: {
    fontWeight: 700,
    fontFamily: "Inter, 'sans-serif'"
  },
  planDetails: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "baseline",
    marginBottom: "3px",
    flexWrap: "wrap",
  },
  boldText: {
    fontWeight: 700,
  },
  priceText: {
    fontSize: "36px",
  },
  mainContainerForm: {
    width: "100%",
    height: "100%",
  },
  container: {
    height: "100%",
    paddingLeft: "0",
    paddingRight: "0"
  },
  fromGrid: {
    display: "flex",
    width: "100%",
    padding: "0 0 20px 0",
    alignItems: "center",
  },
};


class WaitListPaymentDetail extends WaitListController {
  render() {
    const { subscriptionListData } = this.props;
    // Use subscription data from props or state, or use static data
    const subscriptionData = subscriptionListData?.[0] || this.state.customizableSubscriptionData?.[0];
    
    // Static/default price data for display
    const staticPrice = 179; // Default waitlist price
    const staticPlanName = "Waitlist";
    
    const selectedPlan = subscriptionData || null;
    const planPrice = selectedPlan?.attributes?.plans?.[0]?.price || staticPrice;
    const planName = selectedPlan?.attributes?.name || staticPlanName;

    const stripeOptions = {
      clientSecret: this.state.secretKey
    };

    return (
      <ThemeProvider theme={theme}>
        <Container style={webStyles.container} maxWidth="xl">
          <Box
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
              width: "100%",
              padding: "40px",
            }}
            data-test-id="waitListPaymentDetails"
          >
            <Box
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                width: "100%",
                maxWidth: "480px",
              }}
            >
              <Box style={webStyles.headingWrapper}>
                <CustomBackButton handleClick={() => this.setState({ openPaymentModal: false })} />

                <Typography
                  variant="h6"
                  style={webStyles.title}
                  data-test-id="description"
                >
                  Payment Details
                </Typography>
              </Box>
              
              <Box style={webStyles.planDetails}>
                <Typography
                  variant="h6"
                  style={webStyles.boldText}
                  data-test-id="planName"
                >
                  Plan {planName}
                </Typography>
                <Typography
                  data-test-id="planPrice"
                  variant="h6"
                  style={webStyles.boldText}
                >
                  $
                  <span style={webStyles.priceText}>{planPrice}</span>
                  /Month
                </Typography>
              </Box>

              {this.state.secretKey ? (
                <Elements stripe={stripePromise} options={stripeOptions}>
                  <StripeForm
                    goToBack={(e: MouseEvent<HTMLButtonElement>) => this.paymentModal()}
                    handleSubmit={(e: MouseEvent<HTMLButtonElement>, stripe: any, elements: any) => {
                      return this.handleSubmit(e, stripe, elements);
                    }}
                  />
                </Elements>
              ) : (
                <Box style={{ marginTop: "37px", textAlign: "center" }}>
                  <Typography>Loading payment form...</Typography>
                </Box>
              )}
            </Box>
          </Box>
        </Container>
      </ThemeProvider>
    );
  }
}

export default WaitListPaymentDetail;
// Customizable Area End

